import { STATUS_STATISTICS_ENCODED_QUERY_KEY, getHashSearchParams } from './encodedUrlQuery';
import {
    areSearchParamsEqual,
    buildCallsStatisticsSearchParams,
    parseCallsStatisticsUrlState,
    CallsStatisticsUrlWriteState,
} from './callsStatisticsUrlState';

export { areSearchParamsEqual };

const STATUS_FULL_NAME_FILTER_KEY = 'Username';

export function readInitialStatusStatisticsUrlState() {
    const state = parseCallsStatisticsUrlState(getHashSearchParams(), STATUS_STATISTICS_ENCODED_QUERY_KEY);
    return {
        ...state,
        filterFullName: remapFullNameKey(state.filterFullName),
    };
}

export function buildStatusStatisticsSearchParams(state: CallsStatisticsUrlWriteState) {
    return buildCallsStatisticsSearchParams(state, STATUS_STATISTICS_ENCODED_QUERY_KEY);
}

function remapFullNameKey(items: CallsStatisticsUrlWriteState['filterFullName']) {
    if (!items?.length) return null;
    return items.map((item) => ({
        key: STATUS_FULL_NAME_FILTER_KEY,
        value: item.value,
    }));
}
